export const shiftNumberToLongForm = shift => {
  if (shift === 1) {
    return "1st";
  } else if (shift === 2) {
    return "2nd";
  } else if (shift === 3) {
    return "3rd";
  } else {
    return "All Shifts";
  }
};

export const shiftNumberToWord = shift => {
  if (shift === 1) {
    return "1st Shift";
  } else if (shift === 2) {
    return "2nd Shift";
  } else if (shift === 3) {
    return "3rd Shift";
  } else {
    return "All Shifts";
  }
};
